/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class WebhookService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Webhook for healthy
     * @param xWebhookSignature
     * @returns any
     * @throws ApiError
     */
    public handleHealthyWebhook(
        xWebhookSignature: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/webhook/hlthy',
            headers: {
                'x-webhook-signature': xWebhookSignature,
            },
        });
    }

}
